import { Encounter } from "@medplum/fhirtypes";

import { UseFormReturnType } from "@mantine/form";

import { NewbornPostpartumPhysicalExam } from "../zod-schemas/newborn-postpartum-physical-exam";
import { PhysicalExamForm } from "../zod-schemas/physical-exams";

export interface PhysicalExamSectionRecord {
  label: string;
  normalValueSet: string;
  notNormalValueSet: string;
}

export interface PhysicalExamQuestionTypeRecord {
  label: string;
  singleValueSet: string;
}

export interface PhysicalExamSectionValues {
  normal: boolean;
  notNormal: boolean;
  normalDetails: string[];
  notNormalDetails: string[];
  declined: boolean;
  notes?: string;
}

export interface PhysicalExamSingleChoiceValues {
  singleChoice: boolean;
  declined: boolean;
  singleChoiceDetails: string[];
}

export const PHYSICAL_EXAM_SECTION_INITIAL_VALUES: PhysicalExamSectionValues = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const PHYSICAL_EXAM_SINGLE_CHOICE_INITIAL_VALUES: PhysicalExamSingleChoiceValues = {
  singleChoice: false,
  declined: false,
  singleChoiceDetails: [],
};

export interface PhysicalExamOption {
  id: string;
  title: string;
  url: string;
}

export interface PhysicalExamProps {
  url: string;
  submitTrigger: number;
  editable?: boolean;
  isAmendment?: boolean;
}
export interface PhysicalExamsDiffProps {
  currentVersionIndex?: number;
  versionId?: string;
  encounter: Encounter;
}

export interface PhysicalExamItemAnswer {
  type: string;
  sectionName: string;
  items: PhysicalExamSectionValues | PhysicalExamSingleChoiceValues;
}

export interface PhysicalExamNotesAnswer {
  type: string;
  notes: string | undefined;
}

export type PhysicalExamSectionAnswer =
  | PhysicalExamItemAnswer
  | PhysicalExamNotesAnswer
  | undefined;

export type PhysicalExamsGrid = {
  title: string;
  histories: Record<string, PhysicalExamSectionAnswer[][]>;
};

export type PhysicalExamDiffColumn = {
  columnName: string;
  sectionDetails?: (string | undefined)[];
  otherSectionDetails?: (string | undefined)[];
  noteDetails?: string | undefined;
  otherNoteDetails?: string | undefined;
  isPrevious?: boolean;
  showRemoved?: boolean;
  notesType?: boolean;
};

export interface PhysicalExamItemProps {
  name: string;
  sectionLabel: string;
  initial: boolean | undefined;
  label: string;
  url: string;
  form: UseFormReturnType<PhysicalExamForm | NewbornPostpartumPhysicalExam>;
  disabled?: boolean;
  hideDetails?: boolean;
}

export interface PhysicalExamRadioItemProps {
  name: string;
  sectionLabel: string;
  initial: boolean | undefined;
  url: string;
  form: UseFormReturnType<PhysicalExamForm | NewbornPostpartumPhysicalExam>;
  disabled?: boolean;
  hideDetails?: boolean;
}
